import React from "react";
import { CompanyListRow } from "./ComponyListRow";
const CompanyList = ({
  data,
  query,
  fielddata,
  getSelectedBranches,
  selectedBranches,
  TypeOfPortal,
}) => {
  return (
    <div className="CompanyData">
      {!data?.length > 0 ? (
        <p>Data not Avaliable</p>
      ) : (
        <div className="CompanyList">
          {data.map((e, i) => (
            <div key={i}>
              <CompanyListRow
                data={e}
                getSelectedBranches={(data) => getSelectedBranches(data)}
                selectedBranches={selectedBranches}
                fielddata={fielddata}
                TypeOfPortal={TypeOfPortal}
                query={query}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CompanyList;

{
  /* <CompanyListRow
id={company.id}
Company={company.Company}
Unique_Id={company.Unique_Id}
handleSelectCompany={handleSelectCompany}
/> */
}
